const firebaseConfig = {
  apiKey: "AIzaSyADI0wzPFRH42dsW3E2vqe-aaYLe-ZawH4",
  authDomain: "engr-sofie.firebaseapp.com",
  projectId: "engr-sofie",
  storageBucket: "engr-sofie.appspot.com",
  messagingSenderId: "692435926761",
  appId: "1:692435926761:web:2a8020943516220fa47a78"
};
export default firebaseConfig;
